export default "__VITE_PUBLIC_ASSET__a547aad8__"